import {Label} from '@primer/react'

import {FeedbackLink, type OptionalFeedbackLinkProps} from './internal-components/FeedbackLink'
import {LabelWithLink} from './internal-components/LabelWithLink'

export interface NewLabelProps extends OptionalFeedbackLinkProps {
  /** Override label content if necessary. */
  children?: React.ReactNode
  /** Additional class names to apply to the label. */
  className?: string
}

/**
 * Represents a recently-released feature that is available to everyone. Can be used to draw attention to new public
 * features, encouraging users to try them out.
 */
export const NewLabel = ({children = 'New', feedbackUrl, opensInNewTab, className}: NewLabelProps) => (
  <LabelWithLink
    className={className}
    label={<Label variant="accent">{children}</Label>}
    link={feedbackUrl ? <FeedbackLink feedbackUrl={feedbackUrl} opensInNewTab={opensInNewTab} /> : undefined}
  />
)
